import a from "react";
import { getIconColor as h } from "./iconfont.es5470.js";
import g from "./iconfont.es5471.js";
const i = {
  display: "block"
}, x = ({ size: n = 16, useVw: e, useRem: c, color: l, withColor: o, removeClassName: t, disableSSR: m, style: r, ...d }) => {
  const p = r ? { ...i, ...r } : i;
  return /* @__PURE__ */ a.createElement(g, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-yinhangzhuanzhang", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: e ? ((n || 0) / 375 * 100).toFixed(5) + "vw" : n + (c ? "rem" : "px"), height: e ? ((n || 0) / 375 * 100).toFixed(5) + "vw" : n + (c ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: p, fill: "none", ...d }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "24px-é¶è¡è½¬è´¦"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: o ? h(l, 0, "#262933") : "#262933",
        datafollowfill: o ? h(l, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M4.953 4a3.158 3.158 0 0 0-3.158 3.158v9.784A3.158 3.158 0 0 0 4.953 20.1h5.788a.8.8 0 1 0 0-1.6H4.953c-.86 0-1.558-.698-1.558-1.558v-6.885c.318.136.667.21 1.034.21h12.692a.8.8 0 1 0 0-1.6H4.429a1.034 1.034 0 0 1-1.034-1.033v-.476c0-.86.698-1.558 1.558-1.558h13.284c.86 0 1.558.698 1.558 1.558v3.114a.8.8 0 1 0 1.6 0V7.158A3.158 3.158 0 0 0 18.237 4H4.953Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M22.134 14.297c.904.753.372 2.225-.805 2.225H14.8a.8.8 0 1 1 0-1.6h5.585l-1.053-.878a.8.8 0 0 1 1.024-1.23l1.778 1.483Zm-7.331 5.601c-.905-.753-.372-2.225.805-2.225h6.529a.8.8 0 1 1 0 1.6h-5.585l1.053.878a.8.8 0 1 1-1.024 1.23l-1.778-1.483Z"
        }
      )
    )
  )));
}, s = x;
export {
  s as default
};
